import script from "./VideoDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoDetailView.vue?vue&type=script&setup=true&lang=js"

import "./VideoDetailView.vue?vue&type=style&index=0&id=1b94d87e&lang=css"

const __exports__ = script;

export default __exports__